// src/services/useNotify.js
import { useToast } from 'primevue/usetoast'

export function useNotify(group = 'global') {
  const toast = useToast() 

  return {
    success(summary = 'Erfolgreich', detail = '', life = 2500) {
      toast.add({ severity: 'success', summary, detail, life, group })
    },
    error(summary = 'Fehler', detail = '', life = 4000) {
      toast.add({ severity: 'error', summary, detail, life, group })
    },
    warn(summary = 'Hinweis', detail = '', life = 3500) {
      toast.add({ severity: 'warn', summary, detail, life, group })
    },
    info(summary = 'Info', detail = '', life = 3000) {
      toast.add({ severity: 'info', summary, detail, life, group })
    }
  }
}
